import { Navigate, Route, Routes } from "react-router-dom";
import ExtrasView from "../extras-view/extras-view";

export function ExtrasShell() {
  return (
    <Routes>
      <Route path="/" element={<ExtrasView />} />
      <Route path="*" element={<Navigate to="." />} />
    </Routes>
  );
}

export default ExtrasShell;
